import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";
import store from "../src/store/store";
import { IS_STAGING } from "./config/firebaseConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    {IS_STAGING && (
      <div
        style={{
          position: "fixed",
          bottom: 8,
          left: 8,
          zIndex: 99999,
          padding: "3px 10px",
          borderRadius: 4,
          background: "#e01e5a",
          color: "#fff",
          font: "700 11px monospace",
          letterSpacing: 1,
          pointerEvents: "none",
        }}
      >
        STAGING
      </div>
    )}
    <App />
  </Provider>
);
